import {
  action,
  computed,
  makeAutoObservable,
  observable,
  reaction,
  toJS,
} from 'mobx';
import { loadDataHelper, saveDateHelper } from './storeHelpers';
import Agent from 'env/agent';

import { StoreBaseMethods } from './storeBase';
import { commentValidationSchema } from './validationSchemas/commentValidationSchema';
import { validationContext } from 'validx';

const validation = validationContext();
class BlogStore {
  host = null;
  constructor({ data, host, authTokens } = {}) {
    StoreBaseMethods.copyData(data, this);

    this.host = host || data?.host;
    this.authTokens = authTokens;

    makeAutoObservable(this, undefined, { autoBind: true });

    reaction(
      () => toJS(this.newVisitor),
      (newVisitor) => {
        this.newVisitorValidation = validation
          .reset()
          .validate(newVisitor, visitorValidationSchema());
      },
    );

    reaction(
      () => toJS(this.newComment),
      (newComment) => {
        this.newCommentValidation = validation
          .reset()
          .validate(newComment, commentValidationSchema(this, newComment));
      },
    );
  }

  get agent() {
    return new Agent(this.host, this.authTokens);
  }
  @observable isDeletingComment = false;
  @action deleteComment(comment_id) {
    this.isDeletingComment = true;
    return this.agent.Blog.deleteComment(comment_id)
      .then(
        action((data) => {
          if (data.ErrorMessage) throw new Error(data.ErrorMessage);
          return data;
        }),
      )
      .finally(
        action((data) => {
          this.isDeletingComment = false;
          return data;
        }),
      );
  }

  @observable newComment = {};
  @observable newCommentValidation = { errors: {} };
  @action saveNewComment({ blog_id }) {
    return saveDateHelper({
      store: this,
      agentKey: 'Blog',
      key: 'NewComment',
      validation: validation,
      validationSchema: commentValidationSchema(this, this.newComment),
      modelToValidate: this.newComment,
      data: { id: blog_id, ...this.newComment },
    })
      .then(
        action(() => {
          this.newComment = {};
        }),
      )
      .then(
        action(() => {
          this.newCommentValidation = { errors: {} };
        }),
      );
  }

  @computed get homeBlogPosts() {
    return this.blogPosts.filter((a) => a.ShowInHomePage);
  }

  @observable isLoadingBlogPosts = false;
  @observable hasLoadedBlogPosts = false;
  @observable blogPosts = {
    BlogPosts: [],
    Categories: [],
  };
  @action loadBlogPosts({ page, size, query, categoryId, authorId }) {
    return loadDataHelper({
      store: this,
      agentKey: 'Blog',
      key: 'BlogPosts',
      params: { page, size, categoryId, query, authorId },
    });
  }

  @observable isLoadingBlogPostPage = false;
  @observable hasLoadedBlogPostPage = false;
  @observable blogPostPage = {
    BlogPost: {},
  };
  @action loadBlogPostPage(blogId) {
    return loadDataHelper({
      store: this,
      agentKey: 'Blog',
      key: 'BlogPostPage',
      params: blogId,
    });
  }

  @observable isLoadingBannerBlogPosts = false;
  @observable hasLoadedBannerBlogPosts = false;
  @observable bannerBlogPosts = [];
  @action loadBannerBlogPosts() {
    return loadDataHelper({
      store: this,
      agentKey: 'Blog',
      key: 'BannerBlogPosts',
    });
  }

  @observable showAuthor = false;
}
export default BlogStore;
